module.exports = __webpack_public_path__ + "img/eight4Orange.ae72e539.jpg";